import React from 'react'

import { DiNodejsSmall, DiPython, DiDotnet, DiTerminal, DiJavascript, DiJava } from 'react-icons/di'

import style from './SDKS.module.scss'

const icons = {
  java: DiJava,
  python: DiPython,
  node: DiNodejsSmall,
  dotnet: DiDotnet,
  cli: DiTerminal,
  uielements: DiJavascript
}

const SDK = ({
  children,
  language,
  href
}) => {
  const ICON = icons[language]

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={style.sdk}
    >
      <ICON />
      { children }
    </a>
  )
}

export default SDK
